import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  TemplateRef,
} from '@angular/core';
import { AccordionHeaderTemplateContext } from './models/accordion-header-template-context.interface';

@Component({
  selector: 'app-accordion-header',
  templateUrl: './accordion-header.component.html',
  styleUrl: './accordion-header.component.scss',
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AccordionHeaderComponent {
  accordionHeaderTemplate =
    input<TemplateRef<AccordionHeaderTemplateContext>>();
  title = input<string | undefined>();
}
